import Vue from 'vue'
import Vuex from 'vuex'
import i18nStore from './i18n'
import Login from './login'
import Kpi from './kpi'
import Roads from './roads'
import Reports from './reports'
import Planning from './planning'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    i18nStore,
    Login,
    Kpi,
    Roads,
    Reports,
    Planning
  }
})
